export const EarningsLineData = [
  {
    month: "Jan",
    earnings: 1300,
  },
  {
    month: "Feb",
    earnings: 1900,
  },
  {
    month: "Mar",
    earnings: 2000,
  },
  {
    month: "Apr",
    earnings: 1180,
  },
  {
    month: "May",
    earnings: 1890,
  },
  {
    month: "Jun",
    earnings: 2390,
  },
  {
    month: "Jul",
    earnings: 3490,
  },
  {
    month: "Aug",
    earnings: 2490,
  },
  {
    month: "Sep",
    earnings: 320,
  },
  {
    month: "Oct",
    earnings: 1490,
  },
  {
    month: "Nov",
    earnings: 2490,
  },
  {
    month: "Dec",
    earnings: 490,
  },
];

export const UsersLineData = [
  {
    month: "Jan",
    users: 21,
  },
  {
    month: "Feb",
    users: 19,
  },
  {
    month: "Mar",
    users: 45,
  },
  {
    month: "Apr",
    users: 4,
  },
  {
    month: "May",
    users: 90,
  },
  {
    month: "Jun",
    users: 39,
  },
  {
    month: "Jul",
    users: 15,
  },
  {
    month: "Aug",
    users: 24,
  },
  {
    month: "Sep",
    users: 32,
  },
  {
    month: "Oct",
    users: 149,
  },
  {
    month: "Nov",
    users: 290,
  },
  {
    month: "Dec",
    users: 490,
  },
];

export const OrdersLineData = [
  {
    month: "Jan",
    orders: 230,
  },
  {
    month: "Feb",
    orders: 190,
  },
  {
    month: "Mar",
    orders: 459,
  },
  {
    month: "Apr",
    orders: 54,
  },
  {
    month: "May",
    orders: 290,
  },
  {
    month: "Jun",
    orders: 139,
  },
  {
    month: "Jul",
    orders: 185,
  },
  {
    month: "Aug",
    orders: 204,
  },
  {
    month: "Sep",
    orders: 321,
  },
  {
    month: "Oct",
    orders: 109,
  },
  {
    month: "Nov",
    orders: 890,
  },
  {
    month: "Dec",
    orders: 390,
  },
];

export const ProductsLineData = [
  {
    month: "Jan",
    products: 1230,
  },
  {
    month: "Feb",
    products: 1390,
  },
  {
    month: "Mar",
    products: 4590,
  },
  {
    month: "Apr",
    products: 540,
  },
  {
    month: "May",
    products: 2090,
  },
  {
    month: "Jun",
    products: 1339,
  },
  {
    month: "Jul",
    products: 1805,
  },
  {
    month: "Aug",
    products: 2040,
  },
  {
    month: "Sep",
    products: 321,
  },
  {
    month: "Oct",
    products: 1090,
  },
  {
    month: "Nov",
    products: 1890,
  },
  {
    month: "Dec",
    products: 3290,
  },
];
